import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Auth Pages
import Login from './pages/auth/Login';

// Admin Pages
import AdminDashboard from './pages/admin/Dashboard';
import Banks from './pages/admin/Banks';
import Rfcs from './pages/admin/Rfcs';
import Webs from './pages/admin/Webs';
import Users from './pages/admin/Users';
import Templates from './pages/admin/Templates';
import Groups from './pages/admin/Groups';
import GoogleCallback from './pages/GoogleCallback';

// Salesperson/Quote Pages
import QuotesDashboard from './pages/salesperson/QuotesDashboard';
import Quotes from './pages/salesperson/Quotes';
import NewQuote from './pages/salesperson/NewQuote';
import EditQuote from './pages/salesperson/EditQuote';
import QuoteDetail from './pages/salesperson/QuoteDetail';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/google-callback" element={<GoogleCallback />} />

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/banks"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Banks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/rfcs"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Rfcs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/webs"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Webs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/templates"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Templates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/groups"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Groups />
              </ProtectedRoute>
            }
          />

          {/* Salesperson Dashboard */}
          <Route
            path="/salesperson"
            element={
              <ProtectedRoute allowedRoles={['salesperson']}>
                <QuotesDashboard />
              </ProtectedRoute>
            }
          />

          {/* Quote Routes - Both admin and salesperson */}
          <Route
            path="/quotes"
            element={
              <ProtectedRoute allowedRoles={['admin', 'salesperson']}>
                <Quotes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quotes/new"
            element={
              <ProtectedRoute allowedRoles={['admin', 'salesperson']}>
                <NewQuote />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quotes/:id"
            element={
              <ProtectedRoute allowedRoles={['admin', 'salesperson']}>
                <QuoteDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quotes/:id/edit"
            element={
              <ProtectedRoute allowedRoles={['admin', 'salesperson']}>
                <EditQuote />
              </ProtectedRoute>
            }
          />

          {/* Default Redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* 404 - Redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
